import { BalanceSheetNoneType } from "../types"

type NumericFields<T> = {
  [K in keyof T]: T[K] extends number ? K : never
}[keyof T]


export const generateNetProfit = (data: Array<BalanceSheetNoneType>) => {
  const actual =
    getValue(data, "04", "actual") -
    getValue(data, "05", "actual") -
    getValue(data, "06", "actual") +
    (getValue(data, "08", "actual") - getValue(data, "09", "actual"))

  const budget =
    getValue(data, "04", "budget") -
    getValue(data, "05", "budget") -
    getValue(data, "06", "budget") +
    (getValue(data, "08", "budget") - getValue(data, "09", "budget"))

  const variance =
    getValue(data, "04", "variance") -
    getValue(data, "05", "variance") -
    getValue(data, "06", "variance") +
    (getValue(data, "08", "variance") - getValue(data, "09", "variance"))

  const percent_variance =
    getValue(data, "04", "percent_variance") -
    getValue(data, "05", "percent_variance") -
    getValue(data, "06", "percent_variance") +
    (getValue(data, "08", "percent_variance") - getValue(data, "09", "percent_variance"))

  const netProfit: BalanceSheetNoneType = {
    coa_id: -2,
    parent_id: -1,
    group_coa_id: "3",
    header_level: 1,
    coa_level: 1,
    group_coa_code: "00",
    coacode: "",
    coa_name: "NET PROFIT",
    normal_pos: 0,
    linked_code: "",
      actual: actual,
      budget: budget,
      variance: variance,
      percent_variance: percent_variance
  }

  return data.concat([netProfit])
}

const getValue = (
  data: BalanceSheetNoneType[],
  groupCode: string,
  field: NumericFields<BalanceSheetNoneType>
): number => {
  return (
    data.find((coa) => coa.group_coa_code === groupCode && coa.parent_id === -1)?.[field] ?? 0
  )
}